import type { TableFilter } from 'src/generated/graphql';
import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import {
  type BoardPersistUIState,
  initialBoardColumnWidthState,
  initialTableViewState,
} from './types';

const useBoardUIState = create(
  persist<BoardPersistUIState>(
    (set) => ({
      boardsColumnWidth: initialBoardColumnWidthState,
      setColumnWidth: (
        boardId: string,
        tableId: string,
        columnId: string,
        width: number,
      ) =>
        set((state) => {
          return {
            boardsColumnWidth: {
              ...state.boardsColumnWidth,
              [boardId]: {
                ...state.boardsColumnWidth[boardId],
                [tableId]: {
                  ...state.boardsColumnWidth[boardId]?.[tableId],
                  columnsWidth: {
                    ...state.boardsColumnWidth[boardId]?.[tableId]
                      ?.columnsWidth,
                    [columnId]: width,
                  },
                },
              },
            },
          };
        }),
      tableViewHeader: initialTableViewState,
      setGroupBy: (boardId: string, viewId: string, groupBy: string) =>
        set((state) => {
          return {
            tableViewHeader: {
              ...state.tableViewHeader,
              [boardId]: {
                ...state.tableViewHeader[boardId],
                [viewId]: {
                  ...state.tableViewHeader[boardId]?.[viewId],
                  groupBy,
                },
              },
            },
          } as any;
        }),
      setFilter: (boardId: string, viewId: string, filter: TableFilter) =>
        set((state) => {
          return {
            tableViewHeader: {
              ...state.tableViewHeader,
              [boardId]: {
                ...state.tableViewHeader[boardId],
                [viewId]: {
                  ...state.tableViewHeader[boardId]?.[viewId],
                  filter,
                },
              },
            },
          } as any;
        }),
      setSortBy: (
        boardId: string,
        viewId: string,
        sortBy: { column: string; direction: string }[],
      ) =>
        set((state) => {
          return {
            tableViewHeader: {
              ...state.tableViewHeader,
              [boardId]: {
                ...state.tableViewHeader[boardId],
                [viewId]: {
                  ...state.tableViewHeader[boardId]?.[viewId],
                  sortBy,
                },
              },
            },
          } as any;
        }),
      hideActivities: false,
      setBoardHideActivities: (hideActivities: boolean) =>
        set({ hideActivities }),
      boardActivitiesWidth: 500,
      setBoardActivitiesWidth: (boardActivitiesWidth: number) =>
        set({ boardActivitiesWidth }),
      resetBoardUIState: () =>
        set({
          boardsColumnWidth: initialBoardColumnWidthState,
        }),
      hideKanbanLabels: false,
      setHideKanbanLabels: (hideKanbanLabels: boolean) =>
        set({ hideKanbanLabels }),
      kanbanOnlyHeaderColor: false,
      setKanbanOnlyHeaderColor: (kanbanOnlyHeaderColor: boolean) =>
        set({ kanbanOnlyHeaderColor }),
    }),
    {
      name: 'board-ui-state-storage',
      getStorage: () => localStorage,
    },
  ),
);

export default useBoardUIState;
